










































import {defineComponent} from '@vue/composition-api';
import DynamicQuestionMixin from '@/tasks/mixins/dynamic-question';
import StembleLatex from '@/tasks/components/StembleLatex.vue';
import STextarea from '@/common/components/STextarea.vue';

export default defineComponent({
  name: 'UCIrvineChem1LDELN3FSDataAnalysis1',
  components: {STextarea, StembleLatex},
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        productName: null,
        dataAnalysis1CalculationsV: null,
        dataAnalysis1CalculationsDV: null,
      },
      attachments: [] as File[],
      questions: [
        {
          text: 'Provide any written calculations, data values, and explanations for vanillic acid below.',
          inputName: 'dataAnalysis1CalculationsV',
        },
        {
          text: 'Provide any written calculations, data values, and explanations for divanillin below.',
          inputName: 'dataAnalysis1CalculationsDV',
        },
      ],
    };
  },
  computed: {
    attachments(): File[] {
      return [...this.attachments];
    },
  },
});
